import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './DeleteIcon.style';

/** @namespace Bodypwa/Component/DeleteIcon/Component */
export class DeleteIconComponent extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool
    };

    static defaultProps = {
        isActive: false
    };

    render() {
        const { isActive } = this.props;

        return (
            <svg
              block="DeleteIcon"
              mods={ { isActive } }
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M6.4508 8.90625V15.4688H8.0719V8.90625H6.4508Z" />
                <path d="M11.5875 8.90625V15.4688H9.96155V8.90625H11.5875Z" />
                { /* eslint-disable-next-line max-len */ }
                <path fillRule="evenodd" clipRule="evenodd" d="M2.901 4.375V1.98223L4.88323 0H13.4188L15.401 1.98223V4.375H18V6H16.8072V20H1.18225V6H0V4.375H2.901ZM12.901 4.375H5.401V3.01777L5.91877 2.5H12.3832L12.901 3.01777V4.375ZM3.68225 6V17.5H14.3072V6H3.68225Z" />
            </svg>
        );
    }
}

export default DeleteIconComponent;
